import React from 'react';
import { useNavigate } from '@tanstack/react-router';

import type { Memory } from '../../types/memory';

import '@awesome.me/webawesome/dist/components/button-group/button-group.js';

const MemoryButtons: React.FC<{ memory: Memory; page: string }> = ({ memory, page }) => {
  const nav = useNavigate();

  const memoryUrl = memory.timeline_id ? `/timelines/${memory.timeline_id}/${memory.id}` : `/memories/${memory.id}`;

  return (
    <div className="memory-buttons">
      <div className="wa-cluster">
        <div>
          <wa-button-group>
            <wa-button
              appearance={page === 'view' ? 'accent' : 'outlined'}
              onClick={() => nav({ to: memoryUrl })}
            >
              <div className="wa-cluster wa-gap-xs">
                <i className="fa-light fa-eye" />
                View
              </div>
            </wa-button>
            <wa-button
              appearance={page === 'edit' ? 'accent' : 'outlined'}
              onClick={() => nav({ to: `${memoryUrl}/edit` })}
            >
              <div className="wa-cluster wa-gap-xs">
                <i className="fa-light fa-edit" />
                Edit
              </div>
            </wa-button>
          </wa-button-group>
        </div>
        <div>
          <wa-button appearance="outlined" pill size="xs" href={memory.url} target="_blank">
            <div className="wa-cluster wa-gap-xs">
              <i className="fa-light fa-eye" />
              Recipient view
            </div>
          </wa-button>
        </div>
      </div>
    </div>
  );
}

export default MemoryButtons;
